import React, {PureComponent} from "react"
import PropTypes from "prop-types"

import authentication from "@irati/auth"
import {connect} from "@irati/store"
import {getCurrentPosition} from "@irati/geolocation/src/services/fallbackPosition"
import notify from "@irati/utils/notify"
import UserLocationActions from "@irati/geolocation/src/store/actions/UserLocation"
import {injectIntl, LangLoader} from "@irati/utils/lang"
import {SEARCH, PERKSGO} from "@irati-web/app/src/routeConfig"
import isBucketLoaded from "@irati/utils/lang/helpers/isBucketLoaded"

class PerksContainer extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    updateUserLocation: PropTypes.func.isRequired,
    setUserLocationLoad: PropTypes.func.isRequired,
    setUserLocationError: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired
  }

  componentDidMount() {
    const {intl} = this.props
    /*
      @todo: Remove this once we have got rid of react-intl
      react-intl has a bug when using the LangLoader on a bucket that isn't loaded yet -
      it rips out all components and causes them to be re-mounted causing a double componentDidMount.
      This approach checks that the search bucket is loaded first before applying any logic
    */
    if (isBucketLoaded(intl, "search")) {
      if (authentication.apps("platform.geoLocation")) {
        this.loadUserLocation()
      }
    }
  }

  loadUserLocation = () => {
    const {updateUserLocation, setUserLocationError, setUserLocationLoad} = this.props
    const load = getCurrentPosition(5000)
      .then((location) => updateUserLocation(location))
      .catch((error) => {
        setUserLocationError(error)
        notify.error({message: error.message}, this)
      })
    setUserLocationLoad(load)
    return load
  }

  render() {
    const {children} = this.props

    return <LangLoader buckets={[SEARCH, PERKSGO]}>{children}</LangLoader>
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateUserLocation: (location) => dispatch(UserLocationActions.update(location)),
    setUserLocationLoad: (load) => dispatch(UserLocationActions.setLoad(load)),
    setUserLocationError: (error) => dispatch(UserLocationActions.setError(error))
  }
}

export default injectIntl(
  connect(
    null,
    mapDispatchToProps
  )(PerksContainer)
)
